module.exports = __webpack_public_path__ + "static/video-2-1a08db39664d4ae0d215ab2cad9c4c8b.png";